<template>
  <div class="pay-successCon">
    <div class="pay-success flexJC alignItem">
      <span class="paySuccess-icon mb22"></span>
      <p class="f28 mb20">支付成功</p>
      <p class="color-9 f18">您已付款成功，正在为您开锁</p>
      <p class="color-9 f18 pt5">请不要离开，请稍后...</p>
    </div>

    <!-- <audio id="audio_door_opened" width="1" height="1" preload="auto">该浏览器不支持audio属性</audio> -->
    <audio id="audio_door_opened" style="display: none;" src="https://www.aigehui028.com/static/mp/audios/wh-door-opened.aac" preload="auto"></audio>
  </div>
</template>
<script>
import cabinetServ from '../service/cabinetServ'
import cache from '../service/cacheServ'
import mintUi from '../lib/mint-ui'
import preventBack from 'vue-prevent-browser-back'
export default {
  mixins: [preventBack], //禁止返回上一页
  data() {
    return {
      count: '',
      maxOpenCount:0,
      queryCount:0,
      isLoading: false
    }
  },
  created() {
    let cabinetNo = cache.get('cabinetInfo').cabinet.cabinetNo
    let customerWxId = cache.get('user').openId
    let orderNum = this.$route.query.orderNo
    let qrCode = this.$route.query.qrCode
    setTimeout(() => {
      this.getOpenDor(cabinetNo, orderNum, customerWxId, qrCode)
    }, 5000);
  },
  methods: {
    // 定义音乐的自动播放事件
    audioAutoPlay(id) {
      var audio = document.getElementById(id);
      if (window.WeixinJSBridge) {
        WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
          audio.play();
        }, false);
      } else {
        document.addEventListener("WeixinJSBridgeReady", function () {
          WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
            audio.play();
          });
        }, false);
      }
      audio.play();

      return false;
    },
        // 打开柜门
    getOpenDoorFun() {
      let cabinetNo = cache.get('cabinetInfo').cabinet.cabinetNo
      let customerWxId = cache.get('user').openId
      let orderNo = this.$route.query.orderNo
      let qrCode = this.$route.query.qrCode
      this.maxOpenCount++
      cabinetServ.getOpenByOrder(cabinetNo, customerWxId, orderNo, qrCode, '')
        .then(res => {
          if (res.code === '200') {
            this.$router.push({ path: '/openSuccess', query: { qrCode: qrCode, orderNo: orderNo } })
          } else {
            if(this.maxOpenCount>2){
              setTimeout(() => {
                this.$router.push({ path: '/openDoorUnSuccess', query: { qrCode: qrCode, orderNo: orderNo } })
              }, 3000);
            }else{
              setTimeout(() => {
                  this.getOpenDoorFun()
              }, 3000);
            }
          }
        })
    },
    // 查询柜门是否打开
    async getOpenDor(cabinetNo, orderNo, customerWxId, qrCode) {
      this.queryCount++;
      let res = await cabinetServ.getIsOpenDoor(cabinetNo, orderNo, customerWxId, qrCode)
      if (200 === +res.code) {
        if (res.data.cabinetStatus == 'online') { // 在线
          if (!res.data.orderStatus) {
            mintUi.Toast({
              message: '订单不存在，如有疑问请联系管理员',
              position: 'bottom'
            })
          } else {
            if (1 === +res.data.orderStatus&&res.data.doorId) { // 已支付
              if (parseInt(res.data.doorId) > 0) {// 已支付 门已开
                this.audioAutoPlay('audio_door_opened');
                setTimeout(() => {
                  this.$router.push({ path: '/openSuccess', query: { qrCode: qrCode, orderNo: orderNo } })
                }, 4000);
              } else { // 已支付 门未开 去开门
                  setTimeout(() => {
                  this.getOpenDoorFun()
                  }, 3000);
              }
            } else if (2 === +res.data.orderStatus || 3 === +res.data.orderStatus) {// 已借出
              this.audioAutoPlay('audio_door_opened');
              setTimeout(() => {
                this.$router.push({ path: '/openSuccess', query: { qrCode: qrCode, orderNo: orderNo } })
              }, 4000);
            } else if(res.data.orderStatus == '0') { // 未支付继续查询
              if(this.queryCount>9){
                setTimeout(() => {
                  this.$router.push({ path: '/noNormal', query: { qrCode: qrCode, orderNo: orderNo } })
                }, 3000);
              }else{
                setTimeout(() => {
                  this.getOpenDor(cabinetNo, orderNo, customerWxId, qrCode)
                }, 4000);
              }
            }else{
              setTimeout(() => {
                this.$router.push({ path: '/noNormal', query: { qrCode: qrCode, orderNo: orderNo } })
              }, 3000);
            }
          }
        } else {
          setTimeout(() => {
            this.$router.push({ path: '/noNormal', query: { qrCode: qrCode, orderNo: orderNo } })
          }, 3000);
        }
      } else {
        setTimeout(() => {
          this.$router.push({ path: '/noNormal', query: { qrCode: qrCode, orderNo: orderNo } })
        }, 3000);
      }
    },
 
    goToUrl() {
      window.location.href = 'https://www.aigehui028.com/'
    }
  }
}
</script>

<style lang="less" scoped>
.pay-successCon {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 2;
}
.pay-success {
  padding-top: 100px;
}
.pt5 {
  padding-top: 5px;
}
.paySuccess-icon {
  width: 57px;
  height: 57px;
  background: url("/static/images/paySuccess-icon.png") no-repeat;
  background-size: 100% 100%;
}
</style>




// WEBPACK FOOTER //
// src/pages/paySuccess.vue